import axios from '../axios';
import { ONBOARD_MERCHANT } from '../ApiUrl';
import { localStorageKeys } from '../../utils/constants';

function deriveFileName(file) {
  return (
    file.name
      .replace(/\.[^.]+$/, '')
      .replace(/[^a-zA-Z0-9-]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase()
      .slice(0, 50) || 'menu-image'
  );
}

/**
 * Builds multipart payload for POST /OnboardMerchant.
 *
 * Supported fields (current API):
 * - kitchenName (required)
 * - state → MerchantDocument.state
 * - federalEin → MerchantDocument.ein.ein_no
 * - file + fileName + imageType (single menu image)
 * - file + fileNames + imageTypes (multiple menu images, JPEG/PNG only)
 */
export function buildKitchenOnboardingFormData({ kitchenName, state, federalEin, menuFiles = [] }) {
  const formData = new FormData();
  formData.append('kitchenName', kitchenName);
  formData.append('state', state);
  formData.append('federalEin', federalEin);

  if (menuFiles.length > 0) {
    const fileNames = menuFiles.map((file) => deriveFileName(file));

    if (menuFiles.length === 1) {
      formData.append('fileName', fileNames[0]);
      formData.append('imageType', 'menu');
    } else {
      formData.append('fileNames', JSON.stringify(fileNames));
      formData.append('imageTypes', JSON.stringify(menuFiles.map(() => 'menu')));
    }

    menuFiles.forEach((file) => formData.append('file', file));
  }

  return formData;
}

export const updateKitchenOnboardingAPI = async (formData) => {
  try {
    const token = localStorage.getItem(localStorageKeys.TOKEN);
    const response = await axios.post(ONBOARD_MERCHANT, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return response;
  } catch (error) {
    console.log('updateKitchenOnboardingAPI catch block', error);
    return error;
  }
};
